<template>
  <div class="content">
    <div class="i2p-new-page">
      <ed-title-nav :title="'Correct AP File'" :subtitle="''">
        <span slot="action">
          <a href="javascript:;" @click="cancel()">
            <i class="fa fa-long-arrow-left"></i>
            <span>&nbsp; Back</span>
          </a>
        </span>

        <toolbar slot="toolbar">
          <ed-button button-class="btn btn-actionbar-primary pull-right"
                     @click="send()"
                     :disabled="busy"
                     name="send-correct">SEND</ed-button>
          <ed-button button-class="btn btn-actionbar pull-right"
                     @click="cancel()"
                     name="cancel-correct">Cancel</ed-button>
        </toolbar>
      </ed-title-nav>
      <div class="container-fluid">
        <br />

        <div class="page-two-col">
          <aside class="left">
            <section class="msg-details">
              <h4>Message Details</h4>
              <p>
                In addition to the selected user, enter the email address of each person
                or people you would like to copy (CC) or blind carbon copy (BCC) this
                statement to.
              </p>
            </section>
          </aside>

          <section class="right">
            <section class="form-shell">

              <div class="field">
                <funding-address v-if="fundingAddressModel"
                                 :model="fundingAddressModel"
                                 :showEdit=true
                                 @changeAddress="onChangeAddress" />
                <div v-else class="muted">(loading address...)</div>
              </div>

              <div class="field">
                <label>To</label>
                <input class="form-control" type="email" v-model="email.to" readonly />
              </div>

              <div class="field">
                <label>CC <span class="optional">– optional</span></label>
                <input class="form-control" type="text" v-model="email.cc" />
              </div>

              <div class="field">
                <label>BCC <span class="optional">– optional</span></label>
                <input class="form-control" type="text" v-model="email.bcc" />
              </div>

              <div class="field">
                <label>Subject</label>
                <input class="form-control" type="text" v-model="email.subject" />
              </div>

              <div class="field">
                <label>Upload Corrected Funding Statement</label>
                <div class="upload-row">
                  <button class="btn btn-upload"
                          @click="showFsReplace = true"
                          name="replace-funding-statement-btn">
                    UPLOAD FILE
                  </button>
                </div>
              </div>

              <div class="field">
                <label>Attached Funding Statement</label>
                <div class="attached">
                  <span v-if="fundingStatementUrl">
                    <a :href="fundingStatementUrl" target="_blank">{{ fundingStatementName }}</a>
                  </span>
                  <span v-else class="muted">(none)</span>
                </div>
              </div>

              <div class="field">
                <label>Upload Corrected AP File</label>
                <div class="upload-row">
                  <button class="btn btn-upload"
                          @click="showApReplace = true"
                          name="replace-ap-file-btn">
                    UPLOAD FILE
                  </button>
                </div>
              </div>

              <div class="field">
                <label>Attached AP File</label>
                <div class="attached">
                  <span v-if="apFileName">
                    <a :href="apFileUrl" target="_blank">{{ apFileName }}</a>
                  </span>
                  <span v-else class="muted">(none)</span>
                </div>
              </div>

              <div class="field">
                <div class="msg-box" v-html="messageHtml"></div>
              </div>

              <!--<div class="field">
                <label>Additional Documentation <span class="optional">– optional</span></label>
                <div class="upload-row">
                  <button class="btn btn-upload" @click="triggerExtra">UPLOAD FILE</button>
                  <input ref="extraInput" type="file" class="hidden-file" multiple @change="onExtraFiles">
                  <span class="files" v-if="extraFileNames.length">{{ extraFileNames.join(', ') }}</span>
                </div>
              </div>-->
            </section>
          </section>
        </div>
      </div>
    </div>

    <ed-modal :show="showApReplace"
              title="Correct AP File"
              primary-button="Correct"
              secondary-button="Cancel"
              type="medium"
              @close="onApClose"
              @validate="onApSave"
              :validation="true"
              :closeOnEsc="true"
              name="replace_ap_file">
      <div slot="body">
        <section class="col-md-6 no-pad">
          <label>Current AP File</label>
          <p>{{ apFileName || '(none)' }}</p>

          <ed-upload :class="{ loading: !apUploadFinished }"
                     field-label="Attachment"
                     button-label="Upload File"
                     v-model="apAttachmentFiles"
                     readonly
                     :multiple="false"
                     :postAction="api.env + api.$.upload.uploadFile"
                     :uploadAuto="true"
                     :data="apUploadSettings"
                     required
                     @input="onApUploadComplete"
                     :showHelptipIcon="false"
                     helptipHeader=""
                     :error="apAttachmentMissingError"
                     :helptip-body="apAttachmentMissingError && 'Please attach a file.' || ''"
                     name="ap_file_upload" />

          <!--<ed-textarea v-model="apReplaceNotes"
                       field-label="Notes"
                       :required="false"
                       :maxLength="150"
                       name="ap_replace_notes" />-->
        </section>

        <ed-modal :show="apDisplayUploadError"
                  @close="apDisplayUploadError = false"
                  title=""
                  primaryButton="false"
                  secondaryButton="Ok"
                  type="medium"
                  name="replace_ap_file_upload_error">
          <div slot="body">
            <p>{{ apUploadError }}</p>
          </div>
        </ed-modal>
        <div class="clear"></div>
      </div>
    </ed-modal>

    <ed-modal :show="showFsReplace"
              title="Correct Funding Statement"
              primary-button="Correct"
              secondary-button="Cancel"
              type="medium"
              @close="onFsClose"
              @validate="onFsSave"
              :validation="true"
              :closeOnEsc="true"
              name="replace_funding_statement">
      <div slot="body">
        <section class="col-md-6 no-pad">
          <label>Funding Statement</label>
          <p>{{ fundingStatementName || '(none)' }}</p>

          <ed-upload :class="{ loading: !fsUploadFinished }"
                     field-label="Attachment"
                     button-label="Upload File"
                     v-model="fsAttachmentFiles"
                     readonly
                     :multiple="false"
                     :postAction="api.env + api.$.upload.uploadFile"
                     :uploadAuto="true"
                     :data="fsUploadSettings"
                     required
                     @input="onFsUploadComplete"
                     :showHelptipIcon="false"
                     helptipHeader=""
                     :error="fsAttachmentMissingError"
                     :helptip-body="fsAttachmentMissingError && 'Please attach a file.' || ''"
                     name="funding_statement_upload" />
          <!--<ed-textarea v-model="fsPaymentNotes"
                       field-label="Payment Notes"
                       :required="false"
                       :maxLength="150"
                       name="fs_notes" />-->
        </section>

        <ed-modal :show="fsDisplayUploadError"
                  @close="fsDisplayUploadError = false"
                  title=""
                  primaryButton="false"
                  secondaryButton="Ok"
                  type="medium"
                  name="replace_funding_statement_upload_error">
          <div slot="body">
            <p>{{ fsUploadError }}</p>
          </div>
        </ed-modal>
        <div class="clear"></div>
      </div>
    </ed-modal>
  </div>
</template>

<script>
  import toolbar from './Toolbar'
  import FundingAddress from './components/FundingAddress.vue'

  export default {
    name: 'CorrectApFile',
    components: { toolbar, FundingAddress },
    data() {
      const id = Number((this.$route.query || {}).id || 0)
      return {
        id,
        busy: false,
        apiApFileUrl: '',
        apFileName: '',
        fundingAddressModel: null,
        form: {
          fundingAddress:
            ``,
          paymentNotes: ''
        },
        email: {
          to: '',
          cc: '',
          bcc: '',
          subject: '',
          message: ''
        },
        correctedApFile: null,
        extraFiles: [],
        fundingStatementUrl: '',
        fundingStatementName: '',
        auditFileId: 0,
        fundingInvoiceId: 0,

        showFsReplace: false,
        fsPaymentNotes: '',
        fsUploadFinished: true,
        fsAttachmentFiles: null,
        fsAttachmentMissingError: false,
        fsDisplayUploadError: false,
        fsUploadError: '',
        showApReplace: false,
        apReplaceNotes: '',
        apUploadFinished: true,
        apAttachmentFiles: null,
        apAttachmentMissingError: false,
        apDisplayUploadError: false,
        apUploadError: ''
      }
    },
    computed: {
      apFileUrl() { return this.apiApFileUrl || ('/ProgramFusion/GenerateAuditFile?auditFileID=' + this.id) },

      correctedApName() { return this.correctedApFile ? this.correctedApFile.name : '' },

      extraFileNames() { return Array.prototype.map.call(this.extraFiles || [], f => f.name) },

      messageHtml() {
        const raw = (this.email && this.email.message) || ''
        const escaped = raw.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        const withLinks = escaped.replace(/([\w.+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g, '<a href="mailto:$1">$1</a>')
        return withLinks.replace(/\n/g, '<br/>')
      },

      fsUploadSettings() {
        return {
          folder: 'Temp/',
          token: this.$user.sessionSettings.AspxToken,
          fileType: 'pdf',
          renameFile: this.fsAttachmentFiles && this.fsAttachmentFiles[0]
            ? this.fsAttachmentFiles[0].name
            : undefined
        }
      },

      canReplaceFs() {
        return !!(this.uploadToken || this.token)
      },

      apUploadSettings() {
        return {
          folder: 'Temp/',
          token: this.$user.sessionSettings.AspxToken,
          fileType: 'excel/csv',
          renameFile: this.apAttachmentFiles && this.apAttachmentFiles[0]
            ? this.apAttachmentFiles[0].name
            : undefined
        }
      }
    },

    created() {
      this.loadData(false)
    },

    methods: {
      async loadData(isReversal) {
        try {
          this.busy = true
          const { data: r } = await this.api.get(this.api.$.payment.getReversalOrCorrectApFileInfo, {
            params: { apFileId: this.id, isReversal }
          })

          this.fundingAddressModel = this.normalizeAddressModel(r.FundingAddress) || this.fundingAddressModel
          const formatted = this.formatFundingAddress(this.fundingAddressModel) || this.form.fundingAddress
          this.form.fundingAddress = formatted

          this.email.to = r.To || this.email.to
          this.email.cc = typeof r.Cc === 'string' ? r.Cc : this.email.cc
          this.email.subject = r.Subject || this.email.subject
          this.email.message = this.cleanBackendMessage(r.EmailBody || '')
          this.apiApFileUrl = r.APFileUrl || this.apiApFileUrl
          this.fundingStatementUrl = r.FundingStatementUrl || this.fundingStatementUrl
          this.fundingStatementName = this.pickFundingStatementName(r) || this.fundingStatementName || ''
          this.apFileName = r.AuditFileNumber || this.apFileName
          this.auditFileId = r.AuditFileId || r.ApFileId || this.id || 0
          this.fundingStatementId = r.FundingInvoiceId || 0
        } catch (e) {
          console.warn('Failed to load AP info', e)
        } finally {
          this.busy = false
        }
      },

      onChangeAddress(addr) {
        if (typeof addr === 'string') {
          this.form.fundingAddress = addr
        } else {
          this.fundingAddressModel = this.normalizeAddressModel(addr)
          this.form.fundingAddress = this.formatFundingAddress(this.fundingAddressModel)
        }
      },

      normalizeAddressModel(addr) {
        if (!addr) return null
        if (typeof addr === 'string') {
          try {
            return JSON.parse(addr)
          } catch (e) {
            return { Raw: addr }
          }
        }
        return addr
      },

      formatFundingAddress(addr) {
        if (!addr) return ''
        if (addr.Raw && typeof addr.Raw === 'string') return addr.Raw
        if (typeof addr === 'string') return addr
        const parts = [
          addr.Name || addr.Company,
          addr.Address1,
          addr.Address2,
          [addr.City, addr.State || addr.Province, addr.PostalCode].filter(Boolean).join(', '),
          addr.Country
        ].filter(Boolean)
        return parts.join('\n')
      },

      cleanBackendMessage(html) {
        if (!html) return ''
        let s = String(html)

        s = s.replace(/<br\s*\/?>/gi, '\n')

        s = s.replace(/<a[^>]*href=["']mailto:([^"']+)["'][^>]*>[\s\S]*?<\/a>/gi, '$1')

        s = s.replace(/<\/?[^>]+>/g, '')

        s = s
          .replace(/&nbsp;/gi, ' ')
          .replace(/&amp;/gi, '&')
          .replace(/&lt;/gi, '<')
          .replace(/&gt;/gi, '>')
          .replace(/&quot;/gi, '"')
          .replace(/&#39;/g, "'")

        s = s.replace(/[ \t]+\n/g, '\n')
          .replace(/\n{3,}/g, '\n\n')
          .trim()

        return s
      },

      pickFundingStatementName(r) {
        if (!r) return ''

        const src = r.FundingStatementUrl || ''
        if (!src) return ''

        try {
          const u = new URL(src, window.location.origin)
          const m = u.pathname.match(/GenerateFundingInvoicePdf\/([^/?#]+)/i)
          if (m && m[1]) return m[1]

          const inv = u.searchParams.get('fundingInvoiceId')
          if (inv) return inv
        } catch (e) {
          const m2 = String(src).match(/GenerateFundingInvoicePdf\/([^/?#]+)/i)
          if (m2 && m2[1]) return m2[1]
        }

        if (r.FundingInvoiceId) return String(r.FundingInvoiceId)

        return ''
      },

      triggerCorrected() { this.$refs.correctedInput && this.$refs.correctedInput.click() },

      onCorrectedAp(e) { this.correctedApFile = (e.target.files || [])[0] || null },

      triggerExtra() { this.$refs.extraInput && this.$refs.extraInput.click() },

      onExtraFiles(e) { this.extraFiles = e.target.files || [] },

      cancel() { this.$router.push('/i/Programs/Invoice-AP/') },

      getFileExtension(fileName) {
        if (/[.]/.exec(fileName)) {
          const ext = /[^.]+$/.exec(fileName)
          if (ext && ext.length > 0) return ext[0]
        }
        return 'pdf'
      },

      isJson(str) {
        try { JSON.parse(str) } catch (e) { return false }
        return true
      },

      parseFundingStatementIdFromUrl(src) {
        if (!src) return 0
        try {
          const u = new URL(src, window.location.origin)
          const qs = u.searchParams.get('fundingStatementId') || u.searchParams.get('fundingInvoiceId')
          if (qs) return Number(qs) || 0
          const m = u.pathname.match(/Funding(?:Statement|Invoice)\w*\/(\d+)/i)
          if (m && m[1]) return Number(m[1]) || 0
        } catch (e) {
          const m2 = String(src).match(/(\d+)/)
          if (m2 && m2[1]) return Number(m2[1]) || 0
        }
        return 0
      },

      onFsClose() {
        this.showFsReplace = false
        this.fsAttachmentFiles = []
        this.fsPaymentNotes = ''
        this.fsAttachmentMissingError = false
      },

      fsIsValid() {
        const valid = this.fsAttachmentFiles && this.fsAttachmentFiles.length > 0
        this.fsAttachmentMissingError = !valid
        return valid
      },

      onFsSave() {
        if (!this.fsIsValid()) return
        this.doReplaceFundingStatement()
      },

      onFsUploadComplete(e) {
        const completed = e.filter(item =>
          item.success ||
          (!item.success && item.response && typeof item.response === 'string' && !this.isJson(item.response))
        )
        if (completed.length >= 1) this.fsAttachmentMissingError = false

        if (completed.length === e.length) {
          this.fsUploadFinished = true
          e.forEach(item => {
            let resp = null
            if (item.success && item.response) {
              resp = JSON.parse(item.response)
              this.fsUploadError = (resp && resp.uploadError) ? resp.uploadError : ''
            }
            if (!item.success) this.fsUploadError = 'Upload request failed'
          })
          if (this.fsUploadError) this.fsDisplayUploadError = true
          this.fsAttachmentFiles = e.filter(item => item.success && JSON.parse(item.response).success)
        } else {
          this.fsUploadFinished = false
        }
      },

      doReplaceFundingStatement() {
        let uploadedFile = ''
        let fileName = ''

        if (this.fsAttachmentFiles && this.fsAttachmentFiles.length > 0) {
          const fileItem = this.fsAttachmentFiles[0]

          try {
            const resp = JSON.parse(fileItem.response)
            if (resp && resp.success) {
              uploadedFile = resp.file
              fileName = resp.fileName || fileItem.name
            }
          } catch (e) {
            console.warn('Failed to parse upload response', e)
          }
        }

        this.api
          .post(this.api.$.payment.replaceFundingStatement, {
            fundingStatementId: this.fundingStatementId,
            uploadedFile,
            additionalNote: this.fsPaymentNotes
          })
          .then(() => {
            this.fundingStatementName = fileName
            this.onFsClose()
          })
          .catch(err => {
            this.fsUploadError = 'CorrectFundingStatement failed'
            this.fsDisplayUploadError = true
            console.warn('CorrectFundingStatement error', err)
          })
      },

      onApClose() {
        this.showApReplace = false
        this.apAttachmentFiles = []
        this.apReplaceNotes = ''
        this.apAttachmentMissingError = false
      },

      apIsValid() {
        const valid = this.apAttachmentFiles && this.apAttachmentFiles.length > 0
        this.apAttachmentMissingError = !valid
        return valid
      },

      onApSave() {
        if (!this.apIsValid()) return
        this.doReplaceApFile()
      },

      onApUploadComplete(e) {
        const completed = e.filter(item =>
          item.success ||
          (!item.success && item.response && typeof item.response === 'string' && !this.isJson(item.response))
        )
        if (completed.length >= 1) this.apAttachmentMissingError = false

        if (completed.length === e.length) {
          this.apUploadFinished = true
          e.forEach(item => {
            let resp = null
            if (item.success && item.response) {
              try {
                resp = JSON.parse(item.response)
                this.apUploadError = (resp && resp.uploadError) ? resp.uploadError : ''
              } catch (err) {
                this.apUploadError = ''
              }
            }
            if (!item.success) this.apUploadError = 'Upload request failed'
          })
          if (this.apUploadError) this.apDisplayUploadError = true
          this.apAttachmentFiles = e.filter(item => {
            try {
              return item.success && JSON.parse(item.response).success
            } catch (err) {
              return false
            }
          })
        } else {
          this.apUploadFinished = false
        }
      },

      doReplaceApFile() {
        let uploadedFile = ''
        let fileName = ''

        if (this.apAttachmentFiles && this.apAttachmentFiles.length > 0) {
          const fileItem = this.apAttachmentFiles[0]

          try {
            const resp = JSON.parse(fileItem.response)
            if (resp && resp.success) {
              uploadedFile = resp.file
              fileName = resp.fileName || fileItem.name
            }
          } catch (e) {
            console.warn('Failed to parse upload response', e)
          }
        }

        this.api
          .post(this.api.$.payment.correctApFile, {
            auditFileId: this.auditFileId || this.id || 0,
            uploadedFile,
            additionalNote: this.apReplaceNotes
          })
          .then(() => {
            this.apFileName = fileName
            this.onApClose()
          })
          .catch(err => {
            this.apUploadError = 'Correct AP File failed'
            this.apDisplayUploadError = true
            console.warn('Correct AP File error', err)
          })
      },

      send() {
        this.busy = true

        const fd = new FormData()
        fd.append('isReversal', false)

        const auditFile = {
          FundingInvoiceId: this.fundingStatementId || 0,
          AuditFileId: this.auditFileId || 0,
          Subject: this.email.subject || '',
          To: this.email.to || '',
          Bcc: this.email.bcc || '',
          Cc: this.email.cc || '',
          Message: this.email.message || '',
          EmailBody: this.rawEmailBody || this.email.message || '',
          AuditFileNumber: this.apFileName || '',
          FundingAddress: this.fundingAddressModel || {}
        }

        const appendFormData = (data, root = '') => {
          for (const key in data) {
            const value = data[key]
            const formKey = root ? `${root}.${key}` : key

            if (value === null || value === undefined) continue
            if (typeof value === 'object' && !(value instanceof File)) {
              appendFormData(value, formKey)
            } else {
              fd.append(`auditFile.${formKey}`, value)
            }
          }
        }

        appendFormData(auditFile)

        if (this.extraFiles && this.extraFiles.length) {
          this.extraFiles.forEach(f => fd.append('auditFile.Attachments', f))
        }

        this.api.post(this.api.$.payment.sendReversalOrCorrectedApFile, fd)
          .then(() => this.cancel())
          .catch(err => console.warn('Send correct failed', err))
          .finally(() => { this.busy = false })
      }
    }
  }
</script>

<style scoped lang="scss">
  .msg-details {
    max-width: 560px;
    margin-left: 6px;
    margin-bottom: 18px
  }

  .msg-details h4 {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
    color: #333
  }

  .msg-details p {
    margin: 0;
    color: #555;
    line-height: 1.5
  }

  .center-wrap {
    display: flex;
    justify-content: center;
  }

  .form-shell {
    width: 100%;
    max-width: 720px;
  }

  .field {
    margin-bottom: 14px
  }

  .label-row {
    display: flex;
    align-items: center;
    justify-content: space-between
  }

  label {
    display: block;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px
  }

  .form-control {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff
  }

  .address-view {
    white-space: pre-line;
    color: #374151;
    line-height: 1.5
  }

  .attached {
    display: flex;
    align-items: center;
    gap: 10px
  }

  .chip {
    padding: 4px 10px;
    border: 1px solid #cfd3da;
    background: #f6f7fb;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .02em;
  }

  .optional {
    font-style: italic;
    color: #6b7280;
  }

  .btn-upload {
    background: #fff;
    border: 1px solid #2F80ED;
    color: #2F80ED;
    padding: 8px 14px;
    border-radius: 6px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
    transition: background .15s ease, color .15s ease, box-shadow .15s ease, border-color .15s ease;
  }

  .btn-upload:hover {
    background: rgba(47,128,237,.06);
    box-shadow: 0 0 0 3px rgba(47,128,237,.15);
  }

  .btn-upload:active {
    background: rgba(47,128,237,.12);
  }

  .btn-upload:focus {
    outline: 0;
    box-shadow: 0 0 0 3px rgba(47,128,237,.25);
  }

  .hidden-file {
    display: none
  }

  .upload-row {
    display: flex;
    align-items: center;
    gap: 12px
  }

  .files {
    font-size: 12px;
    color: #6b7280
  }

  .muted {
    color: #6b7280
  }

  .page-two-col {
    display: flex;
    align-items: flex-start;
    gap: 32px;
  }

  .left {
    flex: 0 0 320px;
    max-width: 340px;
  }

  .right {
    flex: 1 1 auto;
    max-width: 760px;
  }

  .center-wrap {
    display: block;
  }

  .msg-box {
    background: #f7f8fb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 14px 16px;
    color: #374151;
    line-height: 1.6;
  }

  .msg-box a {
    color: #2F80ED;
    text-decoration: none;
  }

  .msg-box a:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/CorrectApFile.vue